module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAICAYAAAA870V8AAAAAXNSR0IArs4c6QAAADNJREFUCB1j+P//vw0QzwNidiYGBob3QHwViP8xAEXCgPgxEHOBZLiBWAaIGUEcOCCSAwCTgxcJb1k4kwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon--i.png
// module id = B5aD
// module chunks = 1